import { useState } from 'react';
import { Route, Switch } from 'wouter';
import { Carregando } from './componentes/estados.js';
import { Layout } from './layout/Layout.js';
import { useSessao } from './sessao.js';
import { Automacao } from './telas/Automacao.js';
import { Conexao } from './telas/Conexao.js';
import { Dashboard } from './telas/Dashboard.js';
import { Login } from './telas/Login.js';
import { Registro } from './telas/Registro.js';
import { Revisao } from './telas/Revisao.js';
import { Auditoria, Categorias, EmBreve } from './telas/Simples.js';
import { Transacoes } from './telas/Transacoes.js';

/**
 * Rotas do painel.
 *
 * A guarda é simples de propósito: sem usuário, mostra o login e nada mais.
 * Não há rota "protegida" que renderize por um instante antes de redirecionar —
 * o conteúdo do painel nem chega a ser montado.
 */
export function App() {
  const { usuario, carregando } = useSessao();
  const [criandoConta, setCriandoConta] = useState(false);

  if (carregando) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-canvas p-6">
        <div className="w-full max-w-[380px]">
          <Carregando texto="Abrindo o painel..." />
        </div>
      </div>
    );
  }

  if (!usuario) {
    return criandoConta ? (
      <Registro aoVoltar={() => setCriandoConta(false)} />
    ) : (
      <Login aoCriarConta={() => setCriandoConta(true)} />
    );
  }

  return (
    <Layout>
      <Switch>
        <Route path="/" component={Dashboard} />
        <Route path="/transacoes">{() => <Transacoes />}</Route>
        <Route path="/entradas">{() => <Transacoes tipoFixo="entrada" titulo="Entradas" />}</Route>
        <Route path="/saidas">{() => <Transacoes tipoFixo="saida" titulo="Saídas" />}</Route>
        <Route path="/revisao" component={Revisao} />
        <Route path="/categorias" component={Categorias} />
        <Route path="/conexao" component={Conexao} />
        <Route path="/automacao" component={Automacao} />
        <Route path="/auditoria" component={Auditoria} />
        <Route path="/relatorios">
          {() => (
            <EmBreve
              titulo="Relatórios"
              descricao="Os relatórios com gráficos e exportação em planilha entram na próxima entrega."
            />
          )}
        </Route>
        <Route>
          {() => (
            <EmBreve
              titulo="Página não encontrada"
              descricao="Use o menu à esquerda para navegar."
            />
          )}
        </Route>
      </Switch>
    </Layout>
  );
}
